// src/pages/LoginPage.tsx - Updated to fit within main layout
import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { 
  LockClosedIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';
import SpotifyLoginButton from '../components/auth/SpotifyLoginButton';
import { isAuthenticated } from '../services/authService';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnPath = location.state?.returnPath || '/';
  
  // If user is already logged in, redirect
  useEffect(() => {
    if (isAuthenticated()) {
      navigate(returnPath);
    }
  }, [navigate, returnPath]);

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-green-100 p-4">
            <LockClosedIcon className="h-8 w-8 text-green-600" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Sign in with Spotify</h1>
        <p className="text-center text-gray-600 mb-6">
          Connect your Spotify account to manage your artist data
        </p>
        
        <div className="space-y-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-sm font-medium text-gray-700 mb-2">With Spotify authentication you can:</h3>
            <ul className="space-y-2">
              {['Track your streaming metrics', 'Link artist profiles', 'View performance analytics', 'Compare with other artists'].map((item, index) => (
                <li key={index} className="flex items-start">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-gray-600">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="pt-4">
            <SpotifyLoginButton className="w-full py-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;